<template>
  <div>
    <ym-popup v-model="visible"
              class="down-load-tips-popup"
              popup-transition="popup-fade"
              :close-on-click-overlay="closeOnClickOverlay"
              get-container="body"
    >
      <div v-if="title !== ''"
           class="popup-header"
      >
        {{ title }}
      </div>
      <div class="popup-content">
        <span>下载少年商学院APP</span>
        <span>即可离线畅听音频课程</span>
      </div>
      <div class="operate">
        <ym-button class="operate-btn"
                   type="default"
                   size="medium"
                   @click="closePopup"
        >
          取消
        </ym-button>
        <ym-button class="operate-btn"
                   type="primary"
                   size="medium"
                   @click.native="handleDownLoad"
        >
          马上下载
        </ym-button>
      </div>
      <open-app :audio-id="audioId"
                :link-url="linkUrl"
                :name="name"
      >
        <div class="tips">
          已下载，打开App
        </div>
      </open-app>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup, Button } from '@ymba/ym-ui';
  import { decorator, before } from 'ym-reporter-vue';
  import OpenApp from '@/components/OpenApp';

  export default {
    name: 'AudioProgramDownLoad',
    data() {
      return {
        visible: false,
      };
    },
    components: {
      'ym-popup': Popup,
      'ym-button': Button,
      OpenApp,
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      audioId: {
        type: Number,
      },
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false,
      },
      linkUrl: {
        type: String,
        default: '',
      },
      name: String,
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      closePopup() {
        this.visible = false;
      },
      @decorator(before(function () {
        this.$reporter.report('GROWTH_AUDIO_DETAIL_DOWNLOAD_AUDIO_POPUP_DOWNLOAD_CLICK');
      }))
      handleDownLoad() {
        this.$router.push({
          name: 'DownLoad',
        });
      },
    },
    created() {
      this.visible = this.show;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .down-load-tips-popup {
    box-sizing: border-box;
    width: 630px;
    box-shadow: 0 4px 6px 0 fade(@color-black-dark, 25%);
    background-color: @color-white;
    border-radius: @popup-border-radius;
    .popup-header {
      width: 100%;
      height: @popup-header-height;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: @border-base;
      border-radius: @popup-border-radius * 2 @popup-border-radius * 2 0 0;
      color: @color-text-base;
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      white-space: nowrap;
    }
    .popup-content {
      margin-top: @size-extra-medium;
      text-align: center;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      span {
        display: block;
      }
    }

    @operate-btn-margin: @size-base / 2;
    .operate {
      margin: @size-extra-medium -@operate-btn-margin 0;
      padding: 0 @size-medium;
      display: flex;
      justify-content: space-around;

      &-btn {
        margin: 0 @operate-btn-margin;
        border-radius: @border-radius-normal;
      }
    }

    .tips {
      margin: @size-medium 0 @size-base;
      text-align: center;
      color: @color-primary-aide;
      font-size: @font-size-base;
    }
  }
</style>
